import { TYPES } from './types';
import { commitService } from '../services';

// Get all commits
export const getCommits = () => async dispatch => {
  try {
    const res = await commitService.getCommits();
    console.log("getCommits", res.data.data.commits);
    dispatch({
      type: TYPES.ACTION_GET_COMMITS_SUCCESS,
      payload: res.data.data.commits
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_COMMITS_FAIL,
      payload: err.response?.data || { message: 'Error getting commits' }
    });
  }
};

// Get single commit
export const getCommit = (id) => async dispatch => {
  try {
    const res = await commitService.getCommit(id);
    dispatch({
      type: TYPES.ACTION_GET_COMMIT_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_COMMIT_FAIL,
      payload: err.response?.data || { message: 'Error getting commit' }
    });
  }
};

// Update commit
export const updateCommit = (id, commitData) => async dispatch => {
  try {
    const res = await commitService.updateCommit(id, commitData);
    dispatch({
      type: TYPES.ACTION_UPDATE_COMMIT_SUCCESS,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_UPDATE_COMMIT_FAIL,
      payload: err.response?.data || { message: 'Error updating commit' }
    });
  }
}; 